export function transform(data) {
    console.log("transforming data", Object.keys(data?.getUserDetails));
    if(!Array.isArray(data?.getUserDetails?.detail)) {
        return data;
    }

    //add a sequential id to each detail item
    data.getUserDetails.detail.forEach((item, index) => {
        item.id = index + 1;
        item.createdDate = new Date(item.createdDate);
    });

    console.log("transformed data", data);

    return data;
}